import { TeText } from '@topcon/tuicl-react';

export interface CellTextProps {
  text: string;
}

/**
 * Single-line table cell text shared by every `ServerPagedTable` text cell:
 * never wraps (rows stay one line high, per the Figma tables) and ends in an
 * ellipsis when its column is narrower than the text, with the full text in
 * the native tooltip. Only columns with `ServerPagedTableColumn.minWidth` can
 * get narrower than their text.
 */
export default function CellText({ text }: CellTextProps) {
  return (
    <TeText truncate title={text}>
      {text}
    </TeText>
  );
}
